import { render } from "./SearchForm.vue?vue&type=template&id=ca80ad90"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=ca80ad90&lang=css"

import exportComponent from "C:\\TeamCode\\PFSearch\\PFSearch\\pfsearch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__